import React, { useState, useRef, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { useDispatch } from "react-redux";
import { updateUserImage } from "../../../redux/action/auth";

function UploadImage({ src, setOpenCrop }) {
  const dispatch = useDispatch();
  const [crop, setCrop] = useState({
    unit: "%",
    width: 75,
    aspect: 1,
  });
  const [croppedImageUrl, setCroppedImageUrl] = useState(null);
  const imageRef = useRef(null);

  const onImageLoaded = (image) => {
    imageRef.current = image;
    setCrop({
      x: 0,
      y: 0,
      width: image.naturalWidth,
      height: image.naturalHeight,
      unit: "px",
    });
  };

  const onCropComplete = (crop) => {
    makeClientCrop(crop);
  };

  const onCropChange = (crop, percentCrop) => {
    setCrop(crop);
  };

  const makeClientCrop = async (crop) => {
    if (imageRef.current && crop.width && crop.height) {
      const croppedImageUrl = await getCroppedImg(
        imageRef.current,
        crop,
        "newFile.jpeg"
      );
      setCroppedImageUrl(croppedImageUrl);
    }
  };

  const getCroppedImg = (image, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const pixelRatio = window.devicePixelRatio || 1;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            console.error("Canvas is empty");
            return;
          }
          blob.name = fileName;
          window.URL.revokeObjectURL(croppedImageUrl);
          const imageUrl = window.URL.createObjectURL(blob);
          setCroppedImageUrl(imageUrl);
          resolve(imageUrl);
        },
        "image/jpg",
        1
      );
    });
  };

  const uploadCroppedImage = async () => {
    if (croppedImageUrl) {
      const formData = new FormData();
      formData.append("file", croppedImageUrl);

    //   dispatch(updateUserImage(formData));
    }
  };

  return (
    <div className="flex column align-center justify-center full-width  ">
      <b>Updaet Profile Image</b>
      <div className="upload-img flex  justify-center">
        <ReactCrop
          src={src}
          crop={crop}
          ruleOfThirds
          circularCrop={true}
          onImageLoaded={onImageLoaded}
          onComplete={onCropComplete}
          onChange={onCropChange}
          style={{ width: "70%", height: "100%", objectFit: "contain" }}
        />
      </div>
      <div className="flex align-center justify-center gap-1 mt-1 ">
        <button className="btn-outline" onClick={() => setOpenCrop(false)}>
          Close
        </button>
        <button className="btn">SAVE</button>
      </div>
    </div>
  );
}

export default UploadImage;
